// ==============================|| THEME CONSTANT ||============================== //

export const BRAND_NAME = import.meta.env.VITE_BRAND_NAME;
export const LOGO_URL = import.meta.env.VITE_LOGO_URL;
export const APP_DEFAULT_PATH = '/';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

export interface AppConfig {
  fontFamily: string;
}

const config: AppConfig = {
  fontFamily: `'Public Sans', sans-serif`
};

export default config;
